import styled, { css } from 'styled-components';
import { marginLeft, marginTop, paddingLeft, paddingTop } from 'modules/spacing';
const HorizontalColumnSpacing = css `
  ${(props) => paddingLeft(props.$spacing)};
`;
const VerticalColumnSpacing = css `
  ${(props) => paddingTop(props.$spacing)};
`;
export const ColumnContainer = styled.div `
  box-sizing: border-box;
  ${(props) => props.$horizontal && HorizontalColumnSpacing}
  ${(props) => props.$vertical && VerticalColumnSpacing}
`;
const HorizontalGridSpacing = css `
  ${(props) => marginLeft(props.$spacing * -1)};
`;
const VerticalGridSpacing = css `
  ${(props) => marginTop(props.$spacing * -1)};
`;
export const GridContainer = styled.div `
  display: flex;
  flex-flow: row wrap;
  ${(props) => props.$horizontal && HorizontalGridSpacing}
  ${(props) => props.$vertical && VerticalGridSpacing}
`;
